import { Component, OnInit } from '@angular/core';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
  selector: 'app-demographic-otp-verify',
  templateUrl: './demographic-otp-verify.component.html',
  styleUrls: ['./demographic-otp-verify.component.scss'],
  standalone: false
})
export class DemographicOtpVerifyComponent implements OnInit {
  otp: any;
  config = {
    allowNumbersOnly: false,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '40px',
      'height': '40px'
    }
  }
  eye: string = "fa-eye";
  eye2: string = "fa-eye";
  data: any;
  timer: number;
  showTimer: boolean = false;
  showButton: boolean = false
  generatePinObj: any = {
    pin: '',
    confirm_pin: ''
  };
  constructor(
    private modal: DialogConfig,
    public dialog: DialogRef,
    public authenticationService: AuthenticationService,
    private appService: AppService,
    private alerts: AlertsService,
    private loader: LoaderService,
    private baseService: BaseService
  ) { }

  ngOnInit(): void {
    this.data = this.modal.data;
    this.timerFn()
  }

  onOtpChange(otp) {
    this.otp = otp;
    if (otp.length == 6)
      this.showButton = true;
    else
      this.showButton = false;
  }

  verifyPin() {
    if (this.generatePinObj.pin == undefined || this.generatePinObj.pin == "" || this.generatePinObj.pin.length != 4) {
      this.alerts.error("Please enter 4 digit Pin");
      return;
    }
    if (this.generatePinObj.confirm_pin == undefined || this.generatePinObj.confirm_pin == "" || this.generatePinObj.confirm_pin.length != 4) {
      this.alerts.error("Please enter 4 digit Confirm Pin");
      return;
    }
    var account_url;
    if (this.data.isKarexpert != '') {
      account_url = this.data.loginForm.account_url
    } else {
      account_url = window.location.hostname;
    }
    var accountURL = account_url.split('.');
    if (accountURL[0].length < 16) {
      accountURL[0] = accountURL[0] + "0000000000000000".substring(0, (16 - accountURL[0].length));
    } else {
      accountURL[0] = accountURL[0].substring(0, 16);
    }
    let args = 'login_id:' + this.appService.encryptText(accountURL[0], this.data.loginForm.login_id) + ',account_id:' + account_url + ',context:forget_pin,otp_no:' + this.appService.encryptText(accountURL[0], this.otp) + ',pin:' + this.generatePinObj.pin + ',cpin:' + this.generatePinObj.confirm_pin;
    this.baseService.get('VERIFY_OTP_FORGOT_PIN', args, 'otp', 'account-management').subscribe(res => {
      this.loader.hideSpinner()
      if (res.errCode == 0) {
        this.alerts.success(res.message);
        this.dialog.close(true);
      }
      else {
        this.alerts.error(res.message);
      }
    })
  }

  verifyOtp() {
    let obj = {
      "login_id": this.data.id,
      "password": this.otp
    }
    this.baseService.action(obj, 'VERIFY_OTP', 'patient-registration', 'patient').subscribe((result) => {
      if (result.errCode == 0) {
        this.alerts.success(result.message);
        this.dialog.close(true);
      }
      else {
        this.alerts.error(result.message);
      }
    })
  }

  verifyMemberOtp() {
    if (this?.data?.verifyOtpThroughFacilityAdmin) {
      this.verifyOtp();
    } else {
      let obj = {
        "extra_data": {
          "otp_no": this.otp
        },
        "mapped_id": this.data.loginid,
        "user_id": this.data.id
      }
      this.baseService.action(obj, 'VERIFY_OTP', 'account-management', 'user_relationship_mapping').subscribe((result) => {
        if (result.errCode == 0) {
          this.alerts.success(result.message);
          this.dialog.close(true);
        }
        else {
          this.alerts.error(result.message);
        }
      })
    }
  }

  timerFn() {
    this.timer = 60;
    this.showTimer = true;
    let timerInterval = setInterval(() => {
      this.timer -= 1;
      if (this.timer <= 0) {
        clearInterval(timerInterval);
        this.showTimer = false;
      }
    }, 1000)
  }

  resendCode() {
    this.loader.showSpinner()
    let objRefer = {
      "application": "patient-registration",
      "resource": "patient",
      "query_id": "OTP_ON_UPDATE",
      "args": "id:" + this.data.id + ",firstName:" + this.data.name_.text + ",mobileNo:" + this.data.telecom + ",email:" + this.data.emailAddress + ",context:otp"
    }
    this.baseService.getByDataSource(objRefer).subscribe((res) => {
      if (res.errCode == -1) {
        this.alerts.error(res.message)
      }
      else if (res.errCode == 0) {
        this.timerFn()
      }
      this.loader.hideSpinner();

    })
  }

}
